<template>
    <TransitionGroup :appear :name="`wtc--${name}`" :tag>
        <slot></slot>
    </TransitionGroup>
</template>

<script lang="ts" setup>
import { PropType } from "vue";

defineProps({
    name: {
        type: String as PropType<"list" | "grid" | "slide" | "list-sort">,
        default: "list"
    },
    tag: {
        type: String
    },
    appear: {
        type: Boolean,
        default: false
    }
});
</script>

<style lang="scss">
.wtc--slide {
    &-move {
        transition: all 0.5s ease;
    }

    //enter
    &-enter-from {
        opacity: 0;
        transform: translateX(-30px);
    }

    &-enter-active {
        transition: all 0.5s ease;
    }

    &-enter-to {
        opacity: 1;
    }

    //leave
    &-leave-from {
        opacity: 1;
    }

    &-leave-active {
        display: none;
    }

    &-leave-to {
        opacity: 0;
        transform: translateX(-30px);
    }
}

.wtc--list {
    &-move,
    &-enter-active,
    &-leave-active {
        transition: all 0.5s;
    }

    &-enter-from,
    &-leave-to {
        opacity: 0;
        color: transparent;
    }

    &-leave-active {
        position: absolute;
    }
}

.wtc--grid {
    &-move {
        transition: transform 0.25s ease-in-out;
    }

    &-enter-active {
        opacity: 0;
        transition: all 0.2s;
    }

    &-leave-active {
        position: absolute;
        display: none;
    }

    &-leave,
    &-enter-to {
        opacity: 0;
    }
}

.wtc--list-sort {
    &-move {
        transition: all 0.5s ease;
    }
}
</style>
